import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { CURRENCY_PREPENDS } from 'utils/constants'

const useGetPricePrepend = ({ customerData = {}, selectedCustomer = {}, selectedCurrency = '' }) => {
  const { currencyExchangeRatesFF } = useSelector(state => state.featureFlags?.variables || {})
  const { defaultCurrency } = useSelector(state => state.settings)

  const pricePrepend = useMemo(() => {
    if (!currencyExchangeRatesFF) return '$'

    const currency =
      selectedCurrency || (customerData?.id === selectedCustomer?.id && customerData?.defaultCurrency) || null
    if (!currency || currency === defaultCurrency) {
      return CURRENCY_PREPENDS[defaultCurrency]?.hc
    }
    return CURRENCY_PREPENDS[currency]?.fc
  }, [currencyExchangeRatesFF, defaultCurrency, customerData, selectedCustomer, selectedCurrency])

  return {
    pricePrepend,
  }
}

export default useGetPricePrepend
